<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    :height="size"
    viewBox="0 0 15 15"
  >
    <g>
      <path
        :fill="color"
        d="M12.85 3.595l-.512.512-2.275-2.275.513-.512a1.207 1.207 0 0 1 1.708 0l.567.567a1.21 1.21 0 0 1 0 1.708zM1.874 10.48l1.817 1.818-2.513.696zm.454-.911L9.38 2.515l2.275 2.275-7.053 7.053zM12.967.637a2.174 2.174 0 0 0-3.074 0L1.275 9.255a.483.483 0 0 0-.124.212L.018 13.56a.483.483 0 0 0 .594.594l4.091-1.133a.483.483 0 0 0 .213-.124l8.618-8.618a2.176 2.176 0 0 0 0-3.074z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#3B334A',
    },
    size: {
      type: Number,
      default: 12,
    },
  },
};
</script>
